export const CONFIG_SECTIONS = ["portal-credentials"] as const;

export type ConfigSection = (typeof CONFIG_SECTIONS)[number];

export interface ConfigNavItem {
  key: string;
  label: string;
  section: ConfigSection;
}

export interface ConfigNavCategory {
  key: string;
  label: string;
  items: ConfigNavItem[];
}

export const CONFIG_NAV_CATEGORIES: ConfigNavCategory[] = [
  {
    key: "data-provider",
    label: "Data Provider",
    items: [
      {
        key: "portal-credentials",
        label: "Portal Credentials",
        section: "portal-credentials",
      },
    ],
  },
];

export function isConfigSection(
  value: string | undefined,
): value is ConfigSection {
  return (
    typeof value === "string" &&
    (CONFIG_SECTIONS as readonly string[]).includes(value)
  );
}

export function getConfigSectionLabel(section: string): string | null {
  for (const category of CONFIG_NAV_CATEGORIES) {
    const item = category.items.find((navItem) => navItem.section === section);
    if (item) {
      return item.label;
    }
  }
  return null;
}
